<template>
  <div class="step-file-upload" data-testid="step-file-upload__view">
    <div class="step-file-upload__header mb-6">
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        :disabled="!isMultiFileType && dataTable.length === 0"
        @click="onNextStep"
        data-testid="step-file-upload__next-btn"
      >
        <p>Next Step</p>
      </v-btn>
    </div>

    <v-row class="step-file-upload__form-row">
      <v-col cols="12" :sm="configVersion === 2 ? 12 : 6" class="my-0 py-0">
        <lb-dropdown
          label="File Name"
          v-model="localSelectFileName"
          :items="fileItems"
          itemtext="name"
          itemvalue="_id"
          :disabled="true"
          data-testid="step-file-upload__file-name-input"
        />
      </v-col>
      <v-col v-if="configVersion !== 2" cols="12" sm="3" class="my-0 py-0">
        <lb-number
          label="Ignore Rows"
          v-model="ignoreRow"
          min="0"
          @change="getDataSlice()"
          data-testid="step-file-upload__ignore-rows-input"
        />
      </v-col>
      <v-col v-if="configVersion !== 2" cols="12" sm="3" class="my-0 py-0">
        <lb-number
          label="Ignore Columns"
          v-model="ignoreColums"
          @change="getDataSlice()"
          min="0"
          data-testid="step-file-upload__ignore-columns-input"
        />
      </v-col>
    </v-row>

    <v-row class="step-file-upload__form-row">
      <v-col v-if="configVersion !== 2" cols="12" sm="4" class="my-0 py-0">
        <lb-dropdown
          label="Blank Column Headers"
          :items="blankheadersItem"
          v-model="blankheaders"
          data-testid="step-file-upload__blank-headers-input"
        />
      </v-col>
      <v-col cols="12" :sm="configVersion === 2 ? 6 : 4" class="my-0 py-0">
        <lb-number
          label="Number of File Types"
          v-model="numberOfFileTypes"
          min="1"
          max="10"
          data-testid="step-file-upload__file-types-input"
        />
      </v-col>
      <v-col cols="12" :sm="configVersion === 2 ? 6 : 4" class="my-0 py-0">
        <lb-dropdown
          label="Config Version"
          v-model="configVersion"
          :items="configVersionItems"
          itemtext="text"
          itemvalue="value"
          data-testid="step-file-upload__config-version-input"
        />
      </v-col>
    </v-row>

    <v-row v-if="isMultiFileType" class="step-file-upload__form-row">
      <v-col cols="12" v-if="configVersion !== 2" sm="4" class="my-0 py-0">
        <lb-number
          label="Ignore Footer Rows"
          v-model="ignoreFooterRows"
          min="0"
          data-testid="step-file-upload__ignore-footer-rows-input"
        />
      </v-col>
    </v-row>

    <v-row class="step-file-upload__form-row">
      <v-col cols="12" class="my-0 py-0">
        <div class="step-file-upload__note" data-testid="step-file-upload__note">
          <v-icon small>mdi-information-outline</v-icon>
          <span v-if="isMultiFileType">V2 configuration selected. File uploads and column mapping will be done in Step 2.</span>
          <span v-else>Note: Blank rows will be ignored during processing.</span>
        </div>
      </v-col>
    </v-row>

    <div v-if="showHide && !isMultiFileType" class="step-file-upload__upload-row">
      <span class="step-file-upload__upload-label">File Upload</span>
      <lb-file
        v-model="fileSelect"
        label=""
        class="py-0 my-0"
        :drag="false"
        hidedetails
        :displayname="false"
        accept=".xlsx,.xls,.xlsm,.xlsb,.csv"
        @change="selectFileMe()"
        data-testid="step-file-upload__file-input"
      />
      <span v-if="nameFile">
        <v-chip class="ma-2" close @click:close="removeFile()" label data-testid="step-file-upload__file-chip">
          <v-icon left>mdi-file</v-icon>
          <span>{{ nameFile }}</span>
        </v-chip>
      </span>
    </div>

    <div v-if="nameFile && getFinalHeaders.length > 0 && !isMultiFileType" class="step-file-upload__final-headers">
      <h4 class="font-weight-medium mb-1">Final Headers</h4>
      <v-chip
        v-for="(colum, i) in getFinalHeaders"
        :key="'B' + i"
        class="ma-1"
        label
        text-color="primary"
        color="blue-grey lighten-5"
        small
        dense
      >
        <span>{{ colum }}</span>
      </v-chip>
    </div>

    <div v-if="dataTable.length > 0 && !isMultiFileType">
      <v-simple-table
        dense
        v-if="dataTable && showHide"
        class="mb-3 step-file-upload__data-table"
      >
        <thead class="blue-grey lighten-4 align-center font-weight-black tableHeaderBg">
          <th></th>
          <template v-for="vv in displaytablecolumn">
            <th class="text-center pa-1" :key="vv" v-if="vv >= ignoreColums">
              {{ $nova.numToletter(vv) }}
            </th>
          </template>
        </thead>
        <tbody>
          <template v-for="(v, k) in displaytable">
            <tr :key="'B' + k">
              <th id="IgnoreRow" class="font-weight-black px-1 py-0 text-center">
                {{ k + 1 + Math.max(ignoreRow - previewRowWindow, 0) }}
              </th>
              <template v-for="vv in displaytablecolumn">
                <td
                  class="px-1 py-0"
                  v-if="vv >= ignoreColums"
                  :key="vv"
                  :style="{
                    'background-color':
                      (ignoreRow || 0) - Math.max(ignoreRow - previewRowWindow, 0) === k && vv > ignoreColums
                        ? 'yellow'
                        : ''
                  }"
                >
                  {{ v[vv - 1] || "&nbsp;" }}
                </td>
              </template>
            </tr>
          </template>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
/** Number of rows to show before and after the header row in the preview table */
const PREVIEW_ROW_WINDOW = 20;

export default {
  name: 'StepFileUpload',
  props: {
    fileItems: {
      type: Array,
      required: true,
      default: () => [],
    },
    selectFileName: {
      type: String,
      default: null,
    },
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const init = this.initialData || {};
    return {
      previewRowWindow: PREVIEW_ROW_WINDOW,
      localSelectFileName: this.selectFileName,
      ignoreRow: init.ignoreRow || 0,
      ignoreColums: init.ignoreColums || 0,
      nameFile: '',
      fileSelect: null,
      dataTable: [],
      showHide: true,
      displaytable: [],
      displaytablecolumn: 0,
      blankheadersItem: ['left', 'right', 'top', 'bottom'],
      blankheaders: init.blankheaders || 'left',
      blankRows: init.blankRows !== undefined ? init.blankRows : true,
      duplicateColumns: init.duplicateColumns || false,
      numberOfFileTypes: init.numberOfFileTypes || 1,
      ignoreFooterRows: init.ignoreFooterRows || 0,
      configVersion: init.configVersion || 1,
      configVersionItems: [
        { text: 'V1', value: 1 },
        { text: 'V2', value: 2 },
      ],
    };
  },
  computed: {
    isMultiFileType() {
      return this.numberOfFileTypes > 1 || this.configVersion === 2;
    },
    // Allow at most (columnCount - 1) columns to be ignored so at least one column remains.
    maxIgnoreColumns() {
      return this.displaytablecolumn > 0 ? this.displaytablecolumn - 1 : 0;
    },
    getFinalHeaders() {
      if (this.isMultiFileType) return [];
      const selectRow = [...(this.dataTable[this.ignoreRow] || [])];
      let copyindex = 0;
      if (this.blankheaders === 'bottom') copyindex = 1;
      else if (this.blankheaders === 'top') copyindex = -1;
      const blankRow = [...(this.dataTable[this.ignoreRow + copyindex] || [])];

      const selectColumsOne = selectRow.slice(this.ignoreColums) || [];
      const blankColum = blankRow.slice(this.ignoreColums) || [];
      let finalColum = [];
      for (let r = 0; r < (this.displaytablecolumn || selectColumsOne.length); r++) {
        if ((selectColumsOne[r] || '') == '') {
          if (['bottom', 'top'].indexOf(this.blankheaders) > -1)
            finalColum.push(blankColum[r] ?? '');
          else if (this.blankheaders === 'left') finalColum.push(finalColum[r - 1] ?? '');
          else finalColum.push(selectColumsOne[r]);
        } else {
          finalColum.push(selectColumsOne[r]);
        }
      }
      for (let r = selectColumsOne.length - 1; r > -1; r--) {
        if (selectColumsOne[r] == '') {
          if (this.blankheaders === 'right') finalColum[r] = finalColum[r + 1] ?? '';
        }
      }
      finalColum = finalColum.map((x) => (x || '').toString().trim());

      const addfinalCol = finalColum.map((item) => (item === '' ? 'Unnamed' : item)).map((item) => item.replace('.', ''));

      let finalheaders = [];
      if (!this.duplicateColumns) {
        finalheaders = this.renameFiles(addfinalCol);
      } else {
        finalheaders = addfinalCol;
      }
      return [...finalheaders];
    },
  },
  watch: {
    selectFileName(val) {
      this.localSelectFileName = val;
    },
    initialData(val) {
      if (!val) return;
      this.ignoreRow = val.ignoreRow || 0;
      this.ignoreColums = val.ignoreColums || 0;
      this.ignoreFooterRows = val.ignoreFooterRows || 0;
      this.blankheaders = val.blankheaders || 'left';
      this.blankRows = val.blankRows !== undefined ? val.blankRows : true;
      this.duplicateColumns = val.duplicateColumns || false;
      this.numberOfFileTypes = val.numberOfFileTypes || 1;
      this.configVersion = val.configVersion || 1;
    },
    ignoreRow() {
      this.getDataSlice();
    },
    ignoreColums() {
      this.getDataSlice();
    },
  },
  methods: {
    selectFileMe() {
      if (this.fileSelect) {
        this.nameFile = this.fileSelect?.name;
        const file = this.fileSelect;
        Promise.resolve()
          .then(() => {
            const ext = ((file || {}).name || '').split('.').pop();
            if (!file) throw new Error('This file is required!');
            else if (!file.name) throw new Error('Upload a valid file');
            else if (
              ['xls', 'xlsx', 'xlsb'].includes(file.name.split('.').pop().toLowerCase()) &&
              file.size > 1024 * 1024 * 2
            )
              throw new Error('File with size > 2MB should be in csv format');
            else if (['xlsx', 'xls', 'xlsm', 'xlsb'].indexOf(ext) > -1)
              return this.$nova.readExcelFile(file, '', {
                removeblankrows: false,
                columncount: this.displaytablecolumn || 0,
              }, true);
            else if (['csv'].indexOf(ext) > -1)
              return this.$nova.readCSV(file, {
                removeblankrows: false,
                columncount: this.displaytablecolumn || 0,
              });
            throw new Error('Upload a valid file');
          })
          .then((data) => {
            this.dataTable = data;
            this.getDataSlice();
          })
          .catch((err) => {
            this.$store.commit('sbError', err.message || err || 'Unknown error!');
            console.log('[StepFileUpload]:', err);
          });
      }
    },
    getDataSlice() {
      this.displaytablecolumn = 0;
      this.displaytable = this.dataTable.slice(
        Math.max(this.ignoreRow - this.previewRowWindow, 0),
        Math.min(this.ignoreRow + this.previewRowWindow, this.dataTable.length)
      );
      for (const i of this.displaytable) {
        this.displaytablecolumn = Math.max(this.displaytablecolumn, i.length);
      }
      // Clamp ignoreColums so it can never exceed the detected column count.
      if (this.displaytablecolumn > 0 && this.ignoreColums >= this.displaytablecolumn) {
        this.ignoreColums = this.displaytablecolumn - 1;
      }
    },
    removeFile() {
      this.fileSelect = null;
      this.nameFile = '';
      this.dataTable = [];
      this.ignoreRow = 0;
      this.ignoreColums = 0;
    },
    renameFiles(arr) {
      const count = {};
      arr.forEach(function (x, i) {
        if (arr.indexOf(x) !== i) {
          count[x] = count[x] || 0;
          count[x] += 1;
          let c = count[x];
          let j = c + 1;
          let k = x + (j - 1);
          while (arr.indexOf(k) !== -1) k = x + '(' + ++j + ')';
          arr[i] = k;
        }
      });
      return arr;
    },
    onNextStep() {
      if (this.isMultiFileType) {
        this.$emit('next', {
          selectColums: [],
          ignoreRow: this.ignoreRow,
          ignoreColums: this.ignoreColums,
          ignoreFooterRows: this.ignoreFooterRows,
          nameFile: '',
          blankheaders: this.blankheaders,
          blankRows: this.blankRows,
          duplicateColumns: this.duplicateColumns,
          numberOfFileTypes: this.numberOfFileTypes,
          configVersion: this.configVersion,
        });
        return;
      }
      const selectColums = [...this.getFinalHeaders];
      this.$emit('next', {
        selectColums,
        ignoreRow: this.ignoreRow,
        ignoreColums: this.ignoreColums,
        ignoreFooterRows: this.ignoreFooterRows,
        nameFile: this.nameFile,
        blankheaders: this.blankheaders,
        blankRows: this.blankRows,
        duplicateColumns: this.duplicateColumns,
        numberOfFileTypes: this.numberOfFileTypes,
        configVersion: this.configVersion,
      });
    },
  },
  beforeDestroy() {
    this.dataTable = [];
    this.fileSelect = null;
    this.nameFile = '';
    this.displaytable = [];
  },
};
</script>

<style lang="scss" scoped>
@import './StepFileUpload.scss';
</style>
